import React, { useState } from 'react';
import styles from './ProgramCourse.module.scss';
import Buttons from '../../Atoms/Buttons/Buttons';
import AddCourseModal from './AddCourseModal';
import { isEmpty } from 'lodash';
import editSvg from '../../../assets/icons/formActions/edit.svg';
import deleteSvg from '../../../assets/icons/formActions/delete.svg';
import Loader from '../Loader/Loader';
import NoDataComponent from '../Custom/NoDataComponent/NoDataComponent';
import DeletePopup from '../Custom/DeletePopup';
import { useDeleteCourse } from '../../../Hooks/Programs';
import { useToast } from '../Custom/CustomToaster/Toast';
function ProgramCourse({
  detailsToShow,
  isLoading,
  refetchProgram,
  selectedYear,
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteCourse, setISDeleteCourse] = useState(false);
  const [mode, setMode] = useState('Add');
  const [selectedItem, setSelectedItem] = useState({});
  const { mutate: deleteCourse, isLoading: isDeletingCourse } =
    useDeleteCourse();
  const customizedToast = useToast();
  const semesterOnedata = detailsToShow;

  const handleEditClick = (item) => {
    setSelectedItem(item);
    setIsModalOpen(true);
    setMode('Edit');
  };
  const handleDelete = () => {
    deleteCourse(selectedItem?.curDetailId, {
      onSuccess: () => {
        setISDeleteCourse(false);
        customizedToast.open('تم الحذف بنجاح');
        setSelectedItem({});
        refetchProgram();
      },
      onError: (error) => {
        console.error('Error deleting email', error);
        setISDeleteCourse(false);

        setSelectedItem({});
      },
    });
  };

  return (
    <div>
      <div className={styles['course-container']}>
        <div></div>
        <div>
          <Buttons
            text="Add Module"
            rounded={true}
            color="rgba(13, 160, 110, 1)"
            handleOnClick={() => setIsModalOpen(true)}
            style={{ fontFamily: 'BukraMedium' }}
          />
        </div>
      </div>
      <div>
        {isLoading ? (
          <Loader />
        ) : (
          <>
            {isEmpty(semesterOnedata) ? (
              <NoDataComponent />
            ) : (
              <>
                <table className={styles['course-table']}>
                  <thead>
                    <tr>
                      <th colSpan={2}>رصيد المقرر</th>
                      <th colSpan={2}>اسم المقرر</th>
                      <th colSpan={2}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {semesterOnedata &&
                      semesterOnedata.map((course, index) => (
                        <tr key={course.curDetailId}>
                          <td colSpan={2}>{course?.courseCredits}</td>
                          <td colSpan={2}>{course?.courseAR}</td>
                          <td
                            className={styles['edit-delete-cont']}
                            colSpan={2}
                          >
                            <img
                              src={editSvg}
                              alt="editIcon"
                              onClick={() => handleEditClick(course)}
                            />
                            <img
                              src={deleteSvg}
                              alt="deleteIcon"
                              onClick={() => (
                                setISDeleteCourse(true), setSelectedItem(course)
                              )}
                            />
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </>
            )}
          </>
        )}
      </div>
      {isDeleteCourse && (
        <DeletePopup
          title={selectedItem?.courseEN}
          text="دورة"
          handleOnClose={() => (setISDeleteCourse(false), setSelectedItem({}))}
          handleDelete={handleDelete}
          isLoading={isDeletingCourse}
        />
      )}{' '}
      {isModalOpen && (
        <AddCourseModal
          title="Module"
          mode={mode}
          handleOnClose={() => (
            setIsModalOpen(false), setMode('Add'), setSelectedItem({})
          )}
          detailsToShow={detailsToShow}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
          refetchProgram={refetchProgram}
          selectedYear={selectedYear}
        />
      )}
    </div>
  );
}

export default ProgramCourse;
